import { useState } from 'react';
import { Card } from 'antd';
import { Button } from '@bancobarigui/barihaus';
import { CalculatorOutlined } from '@ant-design/icons';
import { InspectionRequest } from '@/services/types/inspection.types';
import { usePreliminaryCalculations } from '../hooks/usePreliminaryCalculations';
import { PreliminaryCalculationsDrawer } from './PreliminaryCalculationsDrawer';

interface PreliminaryCalculationsTabProps {
  inspection: InspectionRequest;
}

export function PreliminaryCalculationsTab({ inspection }: PreliminaryCalculationsTabProps) {
  const [showDrawer, setShowDrawer] = useState(false);
  const preliminaryCalc = usePreliminaryCalculations(inspection);

  return (
    <div className="space-y-6">
      <Card
        style={{ border: '1px solid #d3adf7', background: '#f9f0ff' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <CalculatorOutlined style={{ fontSize: 24, color: '#722ed1' }} />
          <div style={{ flex: 1 }}>
            <strong style={{ color: '#531dab', fontSize: 14 }}>
              Memorial de Cálculo Preliminar
            </strong>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: '#722ed1' }}>
              {preliminaryCalc.hasDraft
                ? 'Dados preliminares salvos. Clique para visualizar ou editar.'
                : 'Adiante a pesquisa de mercado e os cálculos enquanto a vistoria está em andamento.'}
            </p>
          </div>
          <Button
            type={preliminaryCalc.hasDraft ? 'default' : 'primary'}
            icon={<CalculatorOutlined />}
            onClick={() => setShowDrawer(true)}
          >
            {preliminaryCalc.hasDraft ? 'Editar Memorial Preliminar' : 'Preparar Memorial de Cálculo'}
          </Button>
        </div>
      </Card>

      <PreliminaryCalculationsDrawer
        open={showDrawer}
        inspection={inspection}
        initialData={preliminaryCalc.draftData}
        onSave={async (data) => {
          await preliminaryCalc.saveDraft(data);
          setShowDrawer(false);
        }}
        onClose={() => setShowDrawer(false)}
        saving={preliminaryCalc.saving}
      />
    </div>
  );
}
